import(/* webpackMode: "eager", webpackExports: ["default"] */ "/quick/apps/pwa/components/core/EmptyLayout/LangSwitcher.tsx");
;
import(/* webpackMode: "eager" */ "/quick/apps/pwa/styles/utils.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["DarkModeSwitcher"] */ "/quick/libs/components/src/DarkModeSwitcher/DarkModeSwitcher.tsx");
;
import(/* webpackMode: "eager" */ "/quick/node_modules/.pnpm/next@14.2.14_@babel+core@7.24.4_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@_p4h5ly53qqcbdtbbjwsmvyqq2u/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/quick/node_modules/.pnpm/next@14.2.14_@babel+core@7.24.4_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@_p4h5ly53qqcbdtbbjwsmvyqq2u/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
